module.exports = __webpack_public_path__ + "/img/captur-rezultati.d01e786a.jpg";